module.exports = __webpack_public_path__ + "img/icon-energy-energy.7c7c6020.svg";